import { createTheme } from '@mui/material/styles';

export const NAV_BG = '#0f2d5e';
export const AMBER = '#F59E0B';
export const AMBER_DARK = '#D97706';
export const AMBER_GLOW = 'rgba(245,158,11,0.18)';

const theme = createTheme({
    palette: {
        primary: {
            main: NAV_BG,
            light: '#163571',
        },
        secondary: {
            main: AMBER,
            dark: AMBER_DARK,
        },
    },
    typography: {
        fontFamily: '"Outfit", sans-serif',
    },
});

export default theme;
